module.exports = __webpack_public_path__ + "img/fifth_element.1cfeaf38.svg";